import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import { Box, Button, Typography, Container, Paper } from '@mui/material';

interface AssetData {
  txId: string;
  outputIndex: number;
  satoshis: number;
  script: string;
}

const AssetDetails: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [asset, setAsset] = useState<AssetData | null>(null);

  useEffect(() => {
    // Try to load from local storage
    const cachedAssets = localStorage.getItem('wallet_assets');
    if (cachedAssets) {
      const assets: AssetData[] = JSON.parse(cachedAssets);
      const found = assets.find(a => a.txId === id);
      if (found) {
        setAsset(found);
      }
    }
  }, [id]);

  return (
    <>
      <Header />
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Button variant="outlined" onClick={() => navigate('/assets')} sx={{ mb: 2 }}>
          {t('assetDetails.back')}
        </Button>
        
        <Typography variant="h4" gutterBottom>
          {t('assetDetails.title')}
        </Typography>

        {asset ? (
          <Paper sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box>
              <Typography variant="subtitle2" color="textSecondary">{t('assetDetails.txId')}</Typography>
              <Typography variant="body1" sx={{ wordBreak: 'break-all' }}>{asset.txId}</Typography>
            </Box>
            
            <Box>
              <Typography variant="subtitle2" color="textSecondary">{t('assetDetails.outIndex')}</Typography>
              <Typography variant="body1">{asset.outputIndex}</Typography>
            </Box>

            <Box>
              <Typography variant="subtitle2" color="textSecondary">{t('assetDetails.valSats')}</Typography>
              <Typography variant="body1">{asset.satoshis}</Typography>
            </Box>

            <Box>
              <Typography variant="subtitle2" color="textSecondary">{t('assetDetails.scriptHex')}</Typography>
              <Typography variant="body1" sx={{ wordBreak: 'break-all' }}>{asset.script}</Typography>
            </Box>
          </Paper>
        ) : (
          <Typography color="error">
            {t('assetDetails.notFound')}
          </Typography>
        )}
      </Container>
    </>
  );
};

export default AssetDetails;
